import React from "react";
import { motion } from "framer-motion";

const HeroSection = () => {
    return (
        <section
            className="relative w-full h-screen bg-cover bg-center flex items-start justify-center text-center pt-20"
            style={{
                backgroundImage:
                    "url('https://mhcockpit.com/Media/4%20Aviators/About/4-aviators-about.jpg')",
            }}
        >
            {/* Overlay for readability */}
            <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/50 to-transparent"></div>

            {/* Content */}
            <motion.div
                className="relative z-10 px-6 sm:px-10 max-w-3xl"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-snug">
                    Transforming Dreams Into <br className="hidden sm:block" />
                    <span className="text-[#E43038]">Flight Reality</span>
                </h1>

                <p className="mt-4 text-base sm:text-lg md:text-xl">
                    Building the next generation of professional pilots through excellence, innovation, and an unwavering commitment to safety.
                </p>
            </motion.div>
        </section>
    );
};

export default HeroSection;